import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";
import { required, sameAs, minLength, maxLength } from "vuelidate/lib/validators";
import { passwordErrorMessageMixin } from "~/mixins";
import { passwordComplexity } from "~/validators";

export default {
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          app = _ref.app,
          params = _ref.params;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store.commit("dashboard/details/setToolbarTitle", "Profile");

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),

  mixins: [passwordErrorMessageMixin],
  data: function data() {
    return {
      newPassword: true,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      password: "",
      passwordChange: "",
      rules: {
        required: function required(value) {
          return !!value || "Required.";
        },
        min: function min(v) {
          return v.length >= 8 || "Min 8 characters";
        },
        emailMatch: function emailMatch() {
          return "The email and password you entered don't match";
        }
      },
      sending: false,
      timeout: null,
      message: "",
      resultValidatePassword: false
    };
  },

  validations: {
    passwordChange: {
      required: required,
      minLength: minLength(8),
      maxLength: maxLength(12),
      passwordComplexity: passwordComplexity
    },
    password: {
      required: required,
      minLength: minLength(8),
      maxLength: maxLength(12)
    }
  },
  methods: {
    reset: function reset() {
      this.passwordChange = "";
      this.password = "";
      this.$v.$reset();
    },
    changePassword: function changePassword() {
      this.newPassword = !this.newPassword;
      // console.log("se trabaja en el cambio de password");
    },
    onSubmit: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$store.dispatch("user/updatePasswordByRol", {
                  newPassword: this.passwordChange
                });

              case 3:
                this.newPassword = !this.newPassword;
                this.reset();
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                this.$controlMessage(_context2.t0);
                this.reset();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function onSubmit() {
        return _ref3.apply(this, arguments);
      }

      return onSubmit;
    }(),
    ValidatePassword: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                clearTimeout(this.timeout);

                if (!(this.password === "")) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", true);

              case 3:
                _context4.next = 5;
                return this.$store.dispatch("cancelRequest");

              case 5:
                this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;

                          if (!(_this.$isBoss() || _this.$isAdmin() || _this.$isAdminCollaborator())) {
                            _context3.next = 6;
                            break;
                          }

                          _context3.next = 4;
                          return _this.$store.dispatch("boss/validationPasswordBoss", {
                            password: _this.password
                          });

                        case 4:
                          _context3.next = 13;
                          break;

                        case 6:
                          if (!_this.$isSupervisor()) {
                            _context3.next = 11;
                            break;
                          }

                          _context3.next = 9;
                          return _this.$store.dispatch("team/validationPasswordSupervisor", {
                            password: _this.password
                          });

                        case 9:
                          _context3.next = 13;
                          break;

                        case 11:
                          _context3.next = 13;
                          return _this.$store.dispatch("team/validationPasswordSellers", {
                            password: _this.password
                          });

                        case 13:
                          _this.resultValidatePassword = true;
                          _context3.next = 20;
                          break;

                        case 16:
                          _context3.prev = 16;
                          _context3.t0 = _context3["catch"](0);

                          _this.message = _context3.t0.message;
                          _this.resultValidatePassword = false;

                        case 20:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this, [[0, 16]]);
                })), 1000);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ValidatePassword() {
        return _ref4.apply(this, arguments);
      }

      return ValidatePassword;
    }()
  },
  computed: _extends({}, mapState({
    user: function user(state) {
      return state.user;
    }
  }), {
    passwordChangeErrorMessages: function passwordChangeErrorMessages() {
      var errors = [];
      if (!this.$v.passwordChange.$dirty) return errors;
      !this.$v.passwordChange.required && errors.push("Campo obligatorio");
      !this.$v.passwordChange.minLength && errors.push("Debes ingresar al menos " + this.$v.passwordChange.$params.minLength.min + " caracteres");
      !this.$v.passwordChange.passwordComplexity && errors.push("La contrase\xF1a tiene que tener al menos 1 may\xFAscula, al menos 1 min\xFAscula, al menos 1 n\xFAmero y al menos un simbolo");
      this.passwordChangeIsSamePassword && errors.push("Ingrese su nueva contrase\xF1a");
      return errors;
    },
    passwordErrorMessages: function passwordErrorMessages() {
      var errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Campo obligatorio");
      !this.$v.password.minLength && errors.push("Debes ingresar al menos " + this.$v.password.$params.minLength.min + " caracteres"), !this.resultValidatePassword && errors.push(this.message);
      return errors;
    },
    passwordChangeIsSamePassword: function passwordChangeIsSamePassword() {
      return this.passwordChange == this.password ? true : false;
    }
  }),
  watch: {
    password: function password(val) {
      if (val !== this.passwordChange) {
        this.sending = false;
      } else {
        this.sending = true;
      }
    },
    passwordChange: function passwordChange(val) {
      if (val !== this.password) {
        this.sending = false;
      } else {
        this.sending = true;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile.vue
// module chunks = 15